import { trackAmplitudeEvent } from "../../amplitude";

const progressMetricName = (showDaysPlayedInsteadOfStreak) => showDaysPlayedInsteadOfStreak ? "days_played" : "streak";

export default function trackProgressMetricSwitched({ baseLanguageCode, showsDaysPlayedAfter, showsDaysPlayedBefore, targetLanguageCode }) {
  if(showsDaysPlayedAfter === showsDaysPlayedBefore) return;
  trackAmplitudeEvent("progress_metric_switched", {
    base_language: baseLanguageCode,
    from: progressMetricName(showsDaysPlayedBefore),
    language_pair_id: `${baseLanguageCode}-${targetLanguageCode}`,
    target_language: targetLanguageCode,
    to: progressMetricName(showsDaysPlayedAfter)
  });
}
